<div class="loader-container">
  <div class="header"></div>
  <div class="content">
    <div class="dataLoad"></div>
    <div class="dataLoad"></div>
    <div class="dataLoad"></div>
  </div>
  <div style="height: 16px;"></div>
  <div class="header"></div>
  <div class="content">
    <div class="dataLoad"></div>
    <div class="dataLoad"></div>
    <div class="dataLoad"></div>
    </div>
</div>
